import { render, staticRenderFns } from "./inputFilters.vue?vue&type=template&id=453e44c1&"
import script from "./inputFilters.vue?vue&type=script&lang=js&"
export * from "./inputFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports